// extracted by mini-css-extract-plugin
module.exports = {"strip":"TemplatesGrid_strip__n76Fc"};